// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + "reactPlayerPreview" + "." + "a57a98c4" + ".chunk.js";
};